document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  if (!currentPath.startsWith("/about")) {
    return;
  }

  const rawData = document.getElementById("about-behind-force-data");
  const forceContainer = document.querySelector(".behind__force-container");
  const arrowContainer = document.querySelector(".footer__arrows");

  //Logic for mobile carousel
  const btnLeft = document.querySelector(".carousel__arrow--left");
  const btnRight = document.querySelector(".carousel__arrow--right");
  const scrollAmount = 170;

  btnLeft.addEventListener("click", () => {
    forceContainer.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    });
  });

  btnRight.addEventListener("click", () => {
    forceContainer.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  });

  //Logic to get behind the force images, names, titles from ghost admin about page
  if (!rawData || !forceContainer) return;
  const images = Array.from(rawData.querySelectorAll("img")).filter((img) => {
    return !img.closest("figure");
  });

  images.forEach((img) => {
    const entry = document.createElement("div");
    entry.className = "behind__force-footer";

    let next = img.nextSibling;
    const lines = [];

    while (next && lines.length < 2) {
      if (next.nodeType === 3) {
        const text = next.textContent.trim();
        if (text) lines.push(text);
      }
      next = next.nextSibling;
    }

    const name = lines[0] || "No Name";
    const position = lines[1] || "No Position";

    entry.innerHTML = `
      <p class="behind__forcer-info">
        <img src="${img.src}" alt="${name}" class="forcer__img" />
        <span class="behind__forcer-position">${position}</span>
        <span class="behind__forcer-name">${name}</span>
      </p>
    `;

    forceContainer.appendChild(entry);
  });

  if (window.innerWidth <= 1150 || images.length > 4) {
    arrowContainer.style.display = "flex";
  } else if (window.innerWidth <= 768) {
    arrowContainer.style.display = "flex";
  } else {
    arrowContainer.style.display = "none";
  }

  //Logic to get behind the scene images from ghost admin about page
  const galleryImages = rawData.querySelector("figure").querySelectorAll("img");

  if (!galleryImages) return;

  const imageUrls = Array.from(galleryImages)
    .map((img) => img.getAttribute("src"))
    .filter((src) => !!src);

  const behindScenesImages = document
    .getElementById("behind-scenes-container")
    .querySelectorAll("img");

  behindScenesImages.forEach((img, index) => {
    if (imageUrls[index]) {
      img.src = imageUrls[index];
    }
  });
});
